/* eslint-disable jsx-a11y/scope */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {
  useContext,
  useEffect,
  useState,
  useCallback,
  useMemo,
} from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../core/components/NavBar";
import UserContext from "../core/UserContext";
import currencyFormatter from "currency-formatter";
import Moment from "moment";
import { IoPaperPlane } from "react-icons/io5";
import {
  getPolicyClassName,
  getUserDataFromLocalStorage,
  updateObjectInArray,
} from "../core/utils";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import UsePagination from "../core/components/usePagination";
import apiRoutes from "../api/apiRoutes";

const FlexiPolicies = () => {
  const { userData, setUserData } = useContext(UserContext);
  const navigate = useNavigate();
  const userDataStorage = getUserDataFromLocalStorage();
  const axiosPrivate = useAxiosPrivate(userDataStorage);
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sendingContractsToEmail, setSendingContractsToEmail] = useState([]);
  const [sendingContractsToAgent, setSendingContractsToAgent] = useState([]);
  const [paginatedLimit, setPaginatedLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [state, setState] = useState({
    firstname: "",
    lastname: "",
    email: "",
    title: "",
    birth: "",
    phoneNumber: "",
  });

  const canSendContracts = async (_quotation, index) => {
    if (_quotation?.status?.toString().toLowerCase() == "accepted") {
      return true;
    } else {
      return false;
    }
  };

  const sendContractsToEmail = async (application, index) => {
    const url =
      process.env.REACT_APP_API_URL +
      `/quotation/user/email/delivery-contracts/${application.id}`;
    setSendingContractsToEmail(
      updateObjectInArray(sendingContractsToEmail, "index", index, {
        index,
        status: true,
      }),
    );

    try {
      const response = await axiosPrivate.get(url);
      setSendingContractsToEmail(
        updateObjectInArray(sendingContractsToEmail, "index", index, {
          index,
          status: false,
        }),
      );
      if (response.data.success === true) {
        alert("Contracts have been sent to client's email");
      }
    } catch (error) {
      setSendingContractsToEmail(
        updateObjectInArray(sendingContractsToEmail, "index", index, {
          index,
          status: false,
        }),
      );
    }
  };

  const sendContractsToAgent = async (application, index) => {
    const url =
      process.env.REACT_APP_API_URL +
      `/quotation/worker/email/delivery-contracts/${application.id}`;
    setSendingContractsToAgent(
      updateObjectInArray(sendingContractsToAgent, "index", index, {
        index,
        status: true,
      }),
    );

    try {
      const response = await axiosPrivate.get(url);
      setSendingContractsToAgent(
        updateObjectInArray(sendingContractsToAgent, "index", index, {
          index,
          status: false,
        }),
      );
      if (response.data.success === true) {
        alert("Contracts have been sent to agent's email");
      }
    } catch (error) {
      setSendingContractsToAgent(
        updateObjectInArray(sendingContractsToAgent, "index", index, {
          index,
          status: false,
        }),
      );
    }
  };

  const getPolicies = useCallback(async () => {
    const url = process.env.REACT_APP_API_URL + apiRoutes.flexiPolicy;
    setLoading(true);

    try {
      const response = await axiosPrivate.get(url, {
        params: {
          pageSize: paginatedLimit,
          page: currentPage,
        },
      });
      setLoading(false);
      if (response.data.success === true) {
        const filteredPolicies = response.data.data;
        const filteredTotal = response.data.totalItems;

        setTotalItems(filteredTotal);
        setTotalPages(Math.ceil(filteredTotal / paginatedLimit));

        const applicationsSpinners = [];
        const processedPolicies = filteredPolicies.map((policy, index) => {
          applicationsSpinners.push({
            index,
            status: false,
          });
          policy.lives = policy.joinLoan
            ? policy?.user?.name + " | " + policy?.userJoint?.name
            : policy?.user?.name;
          policy.quotationFormData = JSON.parse(policy.quotationFormData);
          return policy;
        });

        setSendingContractsToEmail(applicationsSpinners);
        setSendingContractsToAgent([...applicationsSpinners]);
        setPolicies(processedPolicies);
      }
    } catch (error) {
      setLoading(false);
    }
  }, [paginatedLimit, currentPage, axiosPrivate]);

  const handlePageChange = useCallback((newPage) => {
    setCurrentPage(newPage);
  }, []);

  const handleLimitChange = useCallback((newLimit) => {
    setPaginatedLimit(Number(newLimit));
    setCurrentPage(1);
  }, []);

  const currentItems = useMemo(() => {
    return policies;
  }, [policies]);

  useEffect(() => {
    const data = getUserDataFromLocalStorage();
    getPolicies();
    const firstname = data ? data?.data?.name?.split(" ")[0] : "";
    const lastname = data ? data?.data?.name?.split(" ")[1] : "";
    const email = data ? data?.data?.email : "";
    const title = data ? data?.data?.title : "";
    const phoneNumber = data ? data?.data?.phoneNumber : "";
    const gender = data ? data?.data?.gender : "";
    const birth = data ? new Moment(data?.data?.birth) : "";
    const country = data ? data?.data?.country : "";

    setState({
      firstname,
      lastname,
      title,
      email,
      phoneNumber,
      gender,
      birth,
      country,
    });
  }, [getPolicies]);

  return (
    <>
      <Navbar
        name={
          userData
            ? `${userData?.data?.firstname} ${userData?.data?.lastname}`
            : ""
        }
      />
      <div className="containerx tw-px-3 sm:tw-px-5 tw-w-full tw-max-w-7xl tw-mx-auto">
        <div
          className="mt-4 d-flex justify-content-between align-items-center p-4 px-5 text-white ila-bg"
          style={{ borderRadius: 2 }}
        >
          <h4 className="mb-0 tw-text-xl tw-font-semibold">Policies</h4>
        </div>
        {policies && (
          <>
            <div className="tw-w-full tw-overflow-x-auto">
              <table className="table mt-5 tw-table-auto tw-whitespace-nowrap tw-min-w-full">
                <thead className="tw-font-bold tw-text-black">
                  <tr>
                    <th scope="col">Policy Number</th>
                    <th scope="col">Product</th>
                    <th scope="col">Lives</th>
                    <th scope="col">Sum Assured</th>
                    <th scope="col">Savings Type</th>
                    <th scope="col">Premium</th>
                    <th scope="col">State</th>
                    <th scope="col">Created At</th>
                    <th scope="col">Actions (Contracts)</th>
                  </tr>
                </thead>
                <tbody className="tw-text-black">
                  {currentItems.map((application, index) => {
                    return (
                      <tr className="tw-capitalize" key={index}>
                        <td scope="row">{application.permanentId}</td>
                        <td>
                          {getPolicyClassName(
                            application,
                            application.quotationFormData.loan_plan,
                          )}
                        </td>
                        <td>{application.lives}</td>
                        <td>
                          {currencyFormatter.format(
                            parseFloat(
                              application.quotationFormData.initial_sum_assured,
                            ),
                            { symbol: "Rs " },
                          )}
                        </td>
                        <td>{application?.savingsType}</td>
                        <td>
                          {currencyFormatter.format(
                            parseFloat(application.premiumAmount),
                            {
                              symbol: "Rs ",
                            },
                          )}
                        </td>
                        <td>{application.status}</td>
                        <td>
                          {new Moment(application.createdAt).format("LLL")}
                        </td>
                        <td className="tw-flex tw-w-full tw-gap-2">
                          <a
                            className={`btn btn-light tw-flex-1 tw-inline-flex tw-items-center tw-justify-center ${
                              !application.permanentId ? "disabled" : ""
                            }`}
                            onClick={() => {
                              setSendingContractsToAgent(
                                updateObjectInArray(
                                  sendingContractsToAgent,
                                  "index",
                                  index,
                                  {
                                    index,
                                    status: true,
                                  },
                                ),
                              );
                              canSendContracts(application, index)
                                .then((res) => {
                                  if (res) {
                                    sendContractsToAgent(application, index);
                                  } else {
                                    setSendingContractsToAgent(
                                      updateObjectInArray(
                                        sendingContractsToAgent,
                                        "index",
                                        index,
                                        {
                                          index,
                                          status: false,
                                        },
                                      ),
                                    );
                                    alert(
                                      "Please make sure both lives have verified their details and completed PEP and FATCA questions",
                                    );
                                  }
                                })
                                .catch((err) => {
                                  setSendingContractsToAgent(
                                    updateObjectInArray(
                                      sendingContractsToAgent,
                                      "index",
                                      index,
                                      {
                                        index,
                                        status: false,
                                      },
                                    ),
                                  );
                                  alert(
                                    "Please make sure both lives have verified their details and completed PEP and FATCA questions",
                                  );
                                });
                            }}
                          >
                            {sendingContractsToAgent[index]?.status && (
                              <span className="spinner-border spinner-border-sm me-2"></span>
                            )}
                            <IoPaperPlane className="tw-mr-1.5" size={16} />{" "}
                            Agent
                          </a>
                          <a
                            className={`btn btn-ila !tw-text-white tw-flex-1 tw-inline-flex tw-items-center tw-justify-center ${
                              !application.permanentId ? "disabled" : ""
                            }`}
                            onClick={() => {
                              setSendingContractsToEmail(
                                updateObjectInArray(
                                  sendingContractsToEmail,
                                  "index",
                                  index,
                                  {
                                    index,
                                    status: true,
                                  },
                                ),
                              );
                              canSendContracts(application, index)
                                .then((res) => {
                                  if (res) {
                                    sendContractsToEmail(application, index);
                                  } else {
                                    setSendingContractsToEmail(
                                      updateObjectInArray(
                                        sendingContractsToEmail,
                                        "index",
                                        index,
                                        {
                                          index,
                                          status: false,
                                        },
                                      ),
                                    );
                                    alert(
                                      "Was unable to send email. Kindly contact ILA.",
                                    );
                                  }
                                })
                                .catch((err) => {
                                  setSendingContractsToEmail(
                                    updateObjectInArray(
                                      sendingContractsToEmail,
                                      "index",
                                      index,
                                      {
                                        index,
                                        status: false,
                                      },
                                    ),
                                  );
                                  alert(
                                    "Was unable to send email. Kindly contact ILA.",
                                  );
                                });
                            }}
                          >
                            {sendingContractsToEmail[index]?.status && (
                              <span className="spinner-border spinner-border-sm me-2"></span>
                            )}
                            <IoPaperPlane className="tw-mr-1.5" size={16} />{" "}
                            Client
                          </a>
                          <a
                            className="btn btn-light tw-flex-1 tw-inline-flex tw-items-center tw-justify-center"
                            onClick={() =>
                              navigate(`/clients/${application.id}?source=policies`)
                            }
                          >
                            Contract Parties
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <UsePagination
              pgdrop="tw-hidden"
              limit={paginatedLimit}
              total={totalItems}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              onLimitChange={handleLimitChange}
            />
          </>
        )}

        {loading && (
          <>
            <div
              style={{ marginTop: 150 }}
              className="d-flex flex-column justify-content-center align-items-center"
            >
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div>Please wait...</div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default FlexiPolicies;
